import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var FormInputLabel = styled.span.withConfig({
  displayName: "FormInputLabel",
  componentId: "y7pf1b-0"
})(["color:", ";display:inline-block;font-family:", ";font-size:", ";left:", ";overflow:hidden;padding-right:", ";pointer-events:none;position:absolute;text-overflow:ellipsis;top:", ";transition:0.3s ease all;white-space:nowrap;width:100%;", " ", " ", " ", " ", " ", ""], function (_ref) {
  var skin = _ref.skin,
      theme = _ref.theme;
  return _get(theme, "form.label." + skin + ".color", formTheme.form.label[skin].color);
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'form.label.fontSize', formTheme.form.label.fontSize));
}, rem(12), rem(16), rem(18), function (_ref4) {
  var requiredValue = _ref4.requiredValue;
  return requiredValue && css([":after{content:'*';}"]);
}, function (_ref5) {
  var focused = _ref5.focused,
      filled = _ref5.filled,
      theme = _ref5.theme;
  return (focused || filled) && css(["font-size:", ";top:", ";padding-right:", ";"], rem(_get(theme, 'form.label.fontSizeFocus', formTheme.form.label.fontSizeFocus)), rem(6), rem(16));
}, function (_ref6) {
  var filled = _ref6.filled,
      skin = _ref6.skin,
      theme = _ref6.theme;
  return filled && css(["color:", ";"], _get(theme, "form.label." + skin + ".colorFilled", formTheme.form.label[skin].colorFilled));
}, function (_ref7) {
  var focused = _ref7.focused,
      skin = _ref7.skin,
      theme = _ref7.theme;
  return focused && css(["color:", ";"], _get(theme, "form.label." + skin + ".colorFocus", formTheme.form.label[skin].colorFocus));
}, function (_ref8) {
  var disabledValue = _ref8.disabledValue,
      skin = _ref8.skin,
      theme = _ref8.theme;
  return disabledValue && css(["color:", ";"], _get(theme, "form.label." + skin + ".colorDisabled", formTheme.form.label[skin].colorDisabled));
}, function (_ref9) {
  var error = _ref9.error,
      isSubmitted = _ref9.isSubmitted,
      theme = _ref9.theme;
  return (error || error && isSubmitted) && css(["color:", ";"], _get(theme, 'form.error.color', formTheme.form.error.color));
});
export default FormInputLabel;